import React, { useState } from "react";
import { api } from "@/lib/api";

export default function Track() {
  const [orderId, setOrderId] = useState("");
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setResult(null);
    try { const r = await api.get(`/orders/track/${orderId.trim()}`); setResult(r.data); }
    catch { setErr("Order not found"); }
  };
  return (
    <div className="max-w-lg mx-auto px-6 py-20" data-testid="track-page">
      <h1 className="font-display text-5xl text-[color:var(--hb-navy)] mb-4">Track Your Order</h1>
      <form onSubmit={submit} className="flex gap-2">
        <input value={orderId} onChange={e=>setOrderId(e.target.value)} placeholder="Order ID (ord_...)" className="flex-1 border border-neutral-300 px-3 py-2" data-testid="track-input"/>
        <button className="hb-btn-primary" data-testid="track-btn">Track</button>
      </form>
      {err && <p className="mt-4 text-sm text-[color:var(--hb-red)]">{err}</p>}
      {result && (
        <div className="mt-8 border border-neutral-200 p-6" data-testid="track-result">
          <div className="text-sm font-medium">Order {result.order.order_id}</div>
          <div className="text-xs text-neutral-500 mt-1">${result.order.amount?.toFixed(2)}</div>
          <div className="mt-4 text-sm">Carrier: <b>{result.tracking.carrier}</b></div>
          <div className="text-sm">Status: <b>{result.tracking.status}</b></div>
          <div className="text-sm">ETA: {result.tracking.eta}</div>
        </div>
      )}
    </div>
  );
}
